import { render, staticRenderFns } from "./StockJournal.vue?vue&type=template&id=d3ea0550"
import script from "./StockJournal.vue?vue&type=script&lang=js"
export * from "./StockJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports